export default __webpack_public_path__ + "6a28174ea2da714fd567d275bb885214.png";